import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const navLinks = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综艺', to: '/category/variety' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    setMenuOpen(false);
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <header className="sticky top-0 z-50 bg-primary-950 border-b border-primary-900">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 gap-4">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
              <div className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-logo text-2xl text-background-50 tracking-wide">菠萝蜜网</span>
            </Link>
            <nav className="hidden md:flex items-center gap-1">
              {navLinks.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="px-3 py-2 text-sm font-label text-background-200 hover:text-accent-400 hover:bg-primary-900 rounded-md transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          <form onSubmit={handleSearch} className="hidden md:flex items-center flex-1 max-w-sm">
            <div className="relative w-full">
              <input
                type="text"
                name="keyword"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索电影、剧集、综艺..."
                className="w-full h-10 pl-10 pr-4 rounded-full bg-primary-900 text-sm text-background-50 placeholder:text-background-400 border border-primary-800 focus:outline-none focus:ring-2 focus:ring-accent-500"
              />
              <button
                type="submit"
                aria-label="搜索"
                className="absolute left-0 top-0 h-10 w-10 flex items-center justify-center text-background-300 cursor-pointer"
              >
                <i className="ri-search-line"></i>
              </button>
            </div>
          </form>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-background-50 cursor-pointer"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="菜单"
          >
            <i className={menuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-primary-900 bg-primary-950 px-4 py-4 space-y-4">
          <form onSubmit={handleSearch} className="relative">
            <input
              type="text"
              name="keyword"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索电影、剧集、综艺..."
              className="w-full h-10 pl-10 pr-4 rounded-full bg-primary-900 text-sm text-background-50 placeholder:text-background-400 border border-primary-800 focus:outline-none focus:ring-2 focus:ring-accent-500"
            />
            <button type="submit" aria-label="搜索" className="absolute left-0 top-0 h-10 w-10 flex items-center justify-center text-background-300 cursor-pointer">
              <i className="ri-search-line"></i>
            </button>
          </form>
          <nav className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 text-sm font-label text-background-100 hover:bg-primary-900 rounded-md transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}